<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8B0b7Z/image/cover.jpg?1706297465321" alt="This image is the cover for the book Claw the System"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Claw the System
      </h1>
      <p class="bookDescription body article font2">
        <p>Cats are done with humans' crap. For too long they have put up with baby talk, the humiliation of holiday costumes, and the social injustice of being told, "No." They will not sleep through this anymore. We humans have woken the beast, and in this book they have gathered together to reclaim their voice, loudly and repeatedly until we pay attention. Watch the uprising unfold, through anthems such as "Redefine Terms," "Accepted," "Decide," "A New Dawn," and "Just What Do You Think You're Doing?" Show support for your feline friends and try to understand why they're so spitting mad.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Francesco Marciuliano
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?65cca6aa